import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

Vue.prototype.$dynamic = (key, fallback = '') => {
  return new URLSearchParams(window.location.search).get(key) || fallback
}

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
